import { render, staticRenderFns } from "./TriggerNodeConfig.vue?vue&type=template&id=022ec96e&scoped=true&"
import script from "./TriggerNodeConfig.vue?vue&type=script&lang=js&"
export * from "./TriggerNodeConfig.vue?vue&type=script&lang=js&"
import style0 from "./TriggerNodeConfig.vue?vue&type=style&index=0&id=022ec96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ec96e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('022ec96e')) {
      api.createRecord('022ec96e', component.options)
    } else {
      api.reload('022ec96e', component.options)
    }
    module.hot.accept("./TriggerNodeConfig.vue?vue&type=template&id=022ec96e&scoped=true&", function () {
      api.rerender('022ec96e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/process/comon/process/config/TriggerNodeConfig.vue"
export default component.exports